import React from "react";

const Display=()=>{
  return(
    <>
    </>
  )
}

export default Display